import { StyleSheet } from 'react-native'
import { BaseModalConfig } from '../'
import { translate } from '../../../../../i18n'
import { ConfirmOption } from '../../../BottomModalContent/Content'
import { DS } from '../../../../../design-system'

export interface AppPermissionProps extends BaseModalConfig {
  confirm: ConfirmOption
  cancel: ConfirmOption
}

export const AppPermission = ({ confirm, cancel }: AppPermissionProps) => {
  return (
    <DS.Frame style={styles.container} gap="32">
      <DS.Text variant="Body Medium/Medium" textAlign="center">
        {translate('gameScreen.appPermission')}
      </DS.Text>
      <DS.Frame gap="8">
        <DS.Button variant="Medium/Primary" type={'On Light'} onPress={confirm.onPress}>
          {'Confirm'}
        </DS.Button>
        <DS.Button variant="Medium/Primary" type={'On Dark'} style={styles.button} onPress={cancel.onPress}>
          {'Never mind'}
        </DS.Button>
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 32,
    paddingVertical: 32
  },
  button: {
    backgroundColor: DS.palette['Brand/Cream'],
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  }
})
